import React from 'react';

export default function Spinner3 ({ id ,text}) {
    return (

        <div class="spinner-wrap" id={id}>
            <div class="spinner-load">
                <div class="blockui">
                    <span><b>{text}</b></span>
                    <span class="spinner spinner-track spinner-primary"></span>
                </div>
            </div>
        </div>
    )
}